import { MAIN_PATH } from 'cpmBook/navigation';

const indexComponent = require('./routes/carparks/components/CarparksList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/book'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/book/index.js